var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"update-args":[true, true, true]}})}
var staticRenderFns = []

export { render, staticRenderFns }